import BoxContainerV2 from '@components/Components/Reusables/BoxContainerV2'
import Grid from '@mui/material/GridLegacy'
import Typography from '@mui/material/Typography'

import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import BespokeAccordions from './BespokeAccordions'

export default function Services() {
    return (
        <BoxContainerV2 className="mt-6" mobileClasses="pl-2 pr-2">
            <Typography className="fs-20 fw-bold text-center" as="h1" component="h1">Our Services</Typography>
            <p>At Mobile Bar Hire, we offer a range of services that promise to add sparkle to your event. With Bar Counters and Cash Bar solutions for the events industry the company is a vital component at Festivals, Parties, Weddings and Corporate Events across England, Wales, Scotland and also well into Europe.</p>
            <br />

            <div className='position-relative'>

                <Grid spacing={2} container>
                    <Grid item xs={12} lg={4}>
                        <div className='position-relative'>
                            <Link href="/bar-hire">
                                <Image
                                    className="position-relative h-100 w-100"
                                    src={'/images/MBH/services/top1.jpg'}
                                    fill
                                    style={{
                                        objectFit: 'cover'
                                    }}
                                />
                                <h3 className='m-0'>Bar Hire Packagees</h3>
                                <p>Discover the ideal bar package solution for your requirements in 3 simple steps.</p>
                            </Link>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <div>
                            <Link href="/bar-hire-packages">
                                <Image
                                    className="position-relative h-100 w-100"
                                    src={'/images/MBH/services/top2.jpg'}
                                    fill
                                    style={{
                                        objectFit: 'cover'
                                    }}
                                />
                                <h3 className='m-0'>Bar Hire Packagees</h3>
                                <p>Discover the ideal bar package solution for your requirements in 3 simple steps.</p>
                            </Link>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <div>
                            <Link href="/bar-staff-hire">
                                <Image
                                    className="position-relative h-100 w-100"
                                    src={'/images/MBH/services/top3.jpg'}
                                    fill
                                    style={{
                                        objectFit: 'cover'
                                    }}
                                />
                                <h3 className='m-0'>Bar Hire Packagees</h3>
                                <p>Discover the ideal bar package solution for your requirements in 3 simple steps.</p>
                            </Link>
                        </div>
                    </Grid>
                </Grid>
                <br /><br />

                <Grid spacing={2} container>
                    <Grid item xs={12} lg={6}>
                        <h2 className="m-0">UK {process.env.brand.brand_name}</h2>
                        <p>At Mobile Bar Hire, we offer a range of services that promise to add sparkle to your event. As the UK's leading portable bar hire and drinks hire service, we pride ourselves on providing exceptional service to our customers. Our portable bars are a popular choice to add an extra edge to any event, whether it's a wedding or a corporate party.</p>
                        <p>When you book a service with Mobile Bar Hire, you can count on a five star treatment. We aim to deliver the highest results so you and your guests can enjoy a truly memorable evening. Our bar hire and bartender hire services are available across a range of events and are popular for weddings, birthdays, anniversary parties, corporate events, hen and stag parties, festivals, VIP events, club after parties, and other private hire events.</p>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <div>
                            <Image
                                className="position-relative h-100 w-100"
                                src={'/images/MBH/services/services1.jpg'}
                                fill
                                style={{
                                    objectFit: 'cover'
                                }}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} lg={6}>
                        <div>
                            <Image
                                className="position-relative h-100 w-100"
                                src={'/images/MBH/services/services2.jpg'}
                                fill
                                style={{
                                    objectFit: 'cover'
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <h2 className="m-0">Tailored To Your Needs</h2>
                        <p>You can make use of our range of services tailored to your requirements, which means no matter what you need or what your budget is, we can design a bespoke package for you at Mobile Bar Hire.</p>
                        <p>Our portable bar hire packages are popular for private hire and corporate events alike. With our variety of portable bar models, choosing a bar  has never been easier! Whether it's an ice bar, an ice sculpture , LED cocktail bar , or an island bar we have it all at Mobile Bar Hire. Are you organising a corporate event? Then you'd love our personalised bar hire ideal for branding and marketing purposes.</p>
                    </Grid>
                </Grid>
                <br /><br />
            </div>

            <BespokeAccordions />
        </BoxContainerV2>
    )
}
